import { Configuration } from '@azure/msal-browser';
import config from 'config/config.web';
const {
  VITE_AZURE_DOMAIN,
  VITE_SUSI_FLOW,
  VITE_SUSI_TEST_FLOW,
  VITE_AZURE_CLIENT_ID,
} = config;

export const acquireTokenScopes = [VITE_AZURE_CLIENT_ID ?? ''];

export const LogoutUri = '';

const getLogoutUrl = () => {
  const url = new URL(window.location.href);
  return `${url.protocol}//${url.host}/account/main`;
};

export const loginRequestWeb = {
  scopes: ['profile', 'email', 'offline_access', VITE_AZURE_CLIENT_ID ?? ''],
  popupWindowAttributes: {
    popupSize: {
      height: 700,
      width: 550,
    },
  },
  prompt: 'login',
  redirectStartPage: undefined,
};

export const msalConfigSuSi: Configuration = {
  auth: {
    clientId: VITE_AZURE_CLIENT_ID ?? '',
    authority: `${VITE_AZURE_DOMAIN}/${VITE_SUSI_FLOW}`,
    knownAuthorities: [VITE_AZURE_DOMAIN ?? '', VITE_SUSI_FLOW ?? ''],
    navigateToLoginRequestUrl: true,
    postLogoutRedirectUri: getLogoutUrl(),
  },
  cache: {
    cacheLocation: 'localStorage',
  },
};

export const msalConfigSuSiTest: Configuration = {
  auth: {
    clientId: VITE_AZURE_CLIENT_ID ?? '',
    authority: `${VITE_AZURE_DOMAIN}/${VITE_SUSI_TEST_FLOW}`,
    knownAuthorities: [VITE_AZURE_DOMAIN ?? '', VITE_SUSI_TEST_FLOW ?? ''],
    navigateToLoginRequestUrl: true,
    postLogoutRedirectUri: getLogoutUrl(),
  },
  cache: {
    cacheLocation: 'localStorage',
  },
};

export const AuthConfigSuSi = {};

export const AuthConfigSuSiTest = {};
